<script>
import { mapState } from 'vuex'
import fromPairs from 'lodash/fromPairs'
import date from 'locutus/php/datetime/date'
import {
  fetchPolicyMemberList,
  createPolicyMember,
  deletePolicyMember,
  fetchPolicies,
} from '@apis/admin/affiliate'

export default {
  props: {
    member_seq: {
      default: 0,
      type: [String, Number],
    },
  },
  data() {
    return {
      policies: [],
      member_policies: [],
      s_policy_seq: null,
      loading: false,
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      Promise.all([this.loadPolicies(), this.loadMemberPolicies()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadPolicies() {
      const { data } = await fetchPolicies()

      this.policies = data
    },
    async loadMemberPolicies() {
      const { data } = await fetchPolicyMemberList({
        member_seq: this.member_seq,
        no_paging: 1,
      })

      this.member_policies = data
    },
    async handleCreate() {
      this.loading = true
      try {
        await createPolicyMember({
          member_seq: this.member_seq,
          policy_seq: this.s_policy_seq,
        })

        this.$notify({
          title: this.$t('toasted_msg.title'),
          message: this.$t(
            'member_affiliate_policy.msg_completed_successfully'
          ),
          type: 'success',
        })

        this.init()
      } catch (e) {
        this.$toasted.error(e.message)
      } finally {
        this.loading = false
      }
    },
    async handleDelete(seq) {
      this.loading = true
      try {
        await deletePolicyMember(seq)

        this.$notify({
          title: this.$t('toasted_msg.title'),
          message: this.$t('member_affiliate_policy.msg_successfully_removed'),
          type: 'success',
        })

        this.init()
      } catch (e) {
        this.$toasted.error(e.message)
      } finally {
        this.loading = false
      }
    },
    fromPairs,
    date,
  },
}
</script>

<template>
  <div v-loading="loading">
    <h3 :class="$style.xeAdmin">{{
      $t('member_affiliate_policy.membership_allowance_policy')
    }}</h3>
    <form @submit.prevent="handleCreate">
      <fieldset>
        <select v-model="s_policy_seq">
          <option v-if="policies.length" :value="null">{{
            $t('member_affiliate_policy.msg_select')
          }}</option>
          <option v-else :value="null" :disabled="true">{{
            $t('member_affiliate_policy.msg_not_exist')
          }}</option>
          <option v-for="item in policies" :key="item.seq" :value="item.seq"
            >[{{
              fromPairs(constants.affiliate.policy.target_action)[
                item.target_action
              ]
            }}] {{ item.title }}</option
          >
        </select>
        {{ ' ' }}
        <span
          href="#"
          :class="[$style.button, $style.black]"
          @click.prevent="handleCreate"
          ><input
            type="submit"
            :value="$t('member_affiliate_policy.application')"
        /></span>
      </fieldset>
    </form>
    <table cellspacing="0" cellpadding="0" :class="$style.crossTable">
      <thead>
        <tr>
          <th scope="col"
            ><div>{{ $t('member_affiliate_policy.act_of_subject') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('member_affiliate_policy.policy_title') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('admin.regdate') }}</div></th
          >
          <th scope="col"><div>&nbsp;</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in member_policies" :key="item.seq">
          <td :class="[$style.tCenter, $style.nowrap]">{{
            fromPairs(constants.affiliate.policy.target_action)[
              item.target_action
            ]
          }}</td>
          <td :class="[$style.wide]">{{ item.policy_title }}</td>
          <td :class="[$style.tCenter, $style.nowrap]">{{
            date('Y-m-d H:i:s', new Date(item.regdate))
          }}</td>
          <td :class="[$style.tRight, $style.nowrap]">
            <a
              href="#"
              :class="[$style.button, $style.red]"
              @click.prevent="handleDelete(item.seq)"
              ><span>{{ $t('admin.delete') }}</span></a
            >
          </td>
        </tr>
        <tr v-if="!member_policies.length">
          <td :colspan="5" :class="$style.tCenter">{{
            $t('member_affiliate_policy.msg_no_allowance')
          }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
